import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { originalFacilities } from '../components/FacilitiesSection';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/facility/FacilityDetail.css';

function FacilityDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const facility = originalFacilities.find(f => f.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!facility) {
    return (
      <div className="fd-page">
        <Header />
        <div className="fd-not-found">
          <h2>Facility not found.</h2>
          <button onClick={() => navigate('/#facilities')} className="fd-back-btn">← Back to Facilities</button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="fd-page">
      <Header />

      {/* ── Body ── */}
      <section className="fd-body">

        {/* Tagline + About with Image */}
        <div className="fd-intro">
          <div className="fd-intro-text">
            <span className="fd-tag">Our Facility</span>
            <h1 className="fd-title">{facility.title}</h1>
            <h2>{facility.tagline}</h2>
            <p>{facility.about}</p>
            <button className="fd-cta-btn" onClick={() => navigate('/book-appointment')}>
              Book an Appointment →
            </button>
          </div>

          {/* Image instead of highlights grid */}
          <div className="fd-feature-image">
            <img src={facility.image} alt={facility.title} />
          </div>
        </div>

        {/* Detail cards */}
        <div className="fd-details">
          <h3>What Sets Us Apart</h3>
          <div className="fd-detail-grid">
            {facility.details.map((d, i) => (
              <div className="fd-detail-card" key={i}>
                <div className="fd-detail-num">0{i + 1}</div>
                <h4>{d.heading}</h4>
                <p>{d.body}</p>
              </div>
            ))}
          </div>
        </div>

      </section>

      <Footer />
    </div>
  );
}

export default FacilityDetail;